import React, { Component } from 'react'

import withCssClassName from '../with-css-class-name'

class ContentIcon extends Component {
    render() {
        return (
            <svg {...this.props} xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14"><path fillRule="evenodd" d="M0 8.833V.5A.5.5 0 0 1 .5 0h8.333a.5.5 0 0 1 .5.5v8.333a.5.5 0 0 1-.5.5H.5a.5.5 0 0 1-.5-.5zm3.468 2.784v-1.191h6.385a.55.55 0 0 0 .572-.573V3.468h1.192v8.15H3.468zM14 14H5.851v-1.191h6.385a.55.55 0 0 0 .572-.573V5.851H14V14z"/></svg>
        )
    }
}

export default withCssClassName(ContentIcon)



// WEBPACK FOOTER //
// src/components/svg-icon/icons/content-icon.js